/**
 * Splits an array into smaller chunks of a specified size.
 *
 * @template T - The type of elements in the array.
 *
 * @param {Object} options - An object containing the following options:
 * @param {number} options.chunkSize - The size of each chunk.
 * @param {T[]} options.array - The array to be chunked.
 *
 * @returns {T[][]} An array of arrays, each representing a chunk of the original array.
 *
 * @example
 * const array = [1, 2, 3, 4, 5, 6, 7, 8];
 * const chunkedArray = chunkArray({ chunkSize: 3, array });
 *
 * // chunkedArray is now [[1, 2, 3], [4, 5, 6], [7, 8]]
 */
var chunkArray = function (_a) {
    var chunkSize = _a.chunkSize, array = _a.array;
    var result = array.reduce(function (resultArray, item, index) {
        var chunkIndex = Math.floor(index / chunkSize);
        if (!resultArray[chunkIndex]) {
            resultArray[chunkIndex] = []; // start a new chunk
        }
        resultArray[chunkIndex].push(item);
        return resultArray;
    }, []);
    return result;
};
var isFalsy = function (value) {
    return (value === '' ||
        value === null ||
        value === undefined ||
        (Array.isArray(value) && value.length === 0) ||
        (typeof value === 'object' && Object.keys(value).length === 0));
};
var isValidNumber = function (value) {
    if (isFalsy(value) || typeof value === 'boolean')
        return false;
    return !Number.isNaN(Number(value));
};
export { chunkArray, isFalsy, isValidNumber };
//# sourceMappingURL=common.js.map